import * as fromDatatype from "../../../../models/datatype-library";

export class MemberSuspensionRemarksDtoModel {
    guid: string;
    remarks: string;
}
  